jQuery(function () {
	initScrollToArticle();
	initSlickCarousel();
	initOpenClose();
	initPrint();
});

function initPrint() {
	let btnPrint = document.querySelectorAll("[data-btn-print]");

	btnPrint.forEach((btn) => {
		btn.addEventListener("click", (e) => {
			e.preventDefault();
			window.print();
		});
	});
}

// open-close init
function initOpenClose() {
	jQuery("[data-filter-openClose]").openClose({
		activeClass: "active",
		opener: "[data-filter-opener]",
		slider: "[data-filter-slide]",
		animSpeed: 400,
		effect: "slide",
	});
}

// slick init
function initSlickCarousel() {
	jQuery("[data-image-slider]").slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev">Previous</button>',
		nextArrow: '<button class="slick-next">Next</button>',
		centerMode: true,
		centerPadding: "0px",
		variableWidth: true,
	});
	if( jQuery(".hero-carousel").length ){
		jQuery(".hero-carousel").slick();
	}
}

// scroll to article
function initScrollToArticle() {
	jQuery("[data-target-anchor]").on("click", function (e) {
		e.preventDefault();
		var targetSection = jQuery(this).data("target-anchor");

		$("html, body").animate(
			{
				scrollTop: $(targetSection).offset().top,
			},
			1000
		);
	});
}
